import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.764 4h14.469C20.762 4 22 5.228 22 6.74v7.555c0 1.513-1.238 2.741-2.764 2.741H6.558L2 20V6.74C2 5.229 3.239 4 4.764 4ZM6 13l3-3.5 2.2 2.408L14 7.5l4 5.5H6Z" }));
export default createSvgIcon(iconPath, "SocialPreview");
//# sourceMappingURL=SocialPreviewIcon.js.map